import React from "react";
import { CircularProgress, Grid, styled } from "@mui/material";

const Card = styled("div")({
  maxWidth: "40%",
  minHeight: "20vh",
  display: "flex",
  alignItems: "center",
  background: "transparent",
});

const Loader = styled(CircularProgress)(({ theme }) => ({
  width: 70,
  height: 70,
  color: theme.palette.primary.dark,
}));

const PageLoading = () => {
  return (
    <Grid
      container
      sx={{ height: "100vh" }}
      spacing={0}
      alignItems="center"
      justifyContent="center"
    >
      <Card>
        <Loader size="large" color="primary" />
      </Card>
    </Grid>
  );
};

export default PageLoading;
